const safeFragment = (value: string) => value.trim().toLowerCase().replace(/[^a-z0-9_-]+/g, '_');

const normalizeBookmark = (bookmark: string) => safeFragment(bookmark.replace(/^#/, '').trim()).replace(/-/g, '_');

export function homeSubContext(bookmark?: string) {
  const raw = (bookmark || '').replace(/^#/, '').trim();
  if (!raw || raw === 'top' || raw === 'home') return 'home';
  return `home#${normalizeBookmark(raw)}`;
}

export function homeSubContextDetail(bookmark: string, detail: string) {
  const base = homeSubContext(bookmark);
  const suffix = detail ? `:${safeFragment(detail)}` : '';
  return `${base}${suffix}`;
}

export function isTagItReady() {
  if (typeof window === 'undefined') return false;
  return typeof window.tagItSDK?.trackEvent === 'function';
}

export function trackTagItEvent(event: Record<string, any>) {
  if (typeof window === 'undefined') return;
  const eventSubContext = typeof event?.eventSubContext === 'string' ? event.eventSubContext : undefined;

  // Current `sdk.js` implementation derives `eventSubContext` from SDK instance state (not per-event payload).
  // Keep it in sync so nav clicks and other interactions can update context without re-initializing.
  if (eventSubContext) {
    try {
      if (window.tagItConfig) {
        window.tagItConfig.eventSubContext = eventSubContext;
        if (Array.isArray(window.tagItConfig.data) && window.tagItConfig.data[0]) {
          window.tagItConfig.data[0].eventSubContext = eventSubContext;
        }
      }
      const instance: any = (window as any)._tagItSDKInstance;
      if (instance?.data) {
        instance.data.eventSubContext = eventSubContext;
      }
    } catch {
      // ignore
    }
  }

  window.tagItSDK?.trackEvent?.({
    content: {},
    eventDetails: '',
    ...event,
  });
}

export function trackNav(eventSubContext: string, eventSubType = 'nav') {
  trackTagItEvent({
    eventType: 'engagement',
    eventSubType,
    eventSubContext,
  });
}

export function trackPageView(eventSubContext: string, path?: string) {
  const resolved =
    path && path.trim()
      ? `${eventSubContext}${path.startsWith('#') ? path : `#${path}`}`
      : eventSubContext;
  trackTagItEvent({
    eventType: 'view',
    eventSubType: 'page',
    eventSubContext: resolved,
  });
}

export function trackInquiry(useCase: string) {
  const suffix = useCase ? `:${safeFragment(useCase)}` : '';
  trackTagItEvent({
    eventType: 'conversion',
    eventSubType: 'inquiry_form',
    eventSubContext: `${homeSubContext('inquiry')}${suffix}`,
  });
}

export function safeUseCase(value: string) {
  return safeFragment(value);
}
